import * as React from 'react';

import StaticDocumentsTable from './StaticDocumentsTable';
import { withRouter } from 'react-router';

class StaticDocuments extends React.Component {
  
  state = {
    loading: false,
    status: 'pending',
    searchQuery: ''
  };

  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <div>
        <StaticDocumentsTable domain={(this.props as any).match.params.eshop} />
      </div>
    );
  }
}

export default withRouter(StaticDocuments)


// WEBPACK FOOTER //
// ./src/scenes/StaticDocuments/index.tsx